import { Injectable } from "@angular/core";
import { AffiliateService } from "@obg/ngx.common";
import { CoreHttpClient, DepositLimitPeriod, Jurisdiction, ProductType } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { SeamlessRegistrationConfigService } from "./seamless-registration.config";
import { SEAMLESS_REGISTRATION_PROVIDER_TYPE } from "./seamless-registration.const";
import {
	CreateSeamlessRegistrationRequest,
	SeamlessRegistrationPayload,
	SeamlessRegistrationReferenceResponse,
	SeamlessRegistrationRequest,
	SeamlessRegistrationResponse,
} from "./seamless-registration.model";

@Injectable({
	providedIn: "root",
})
export class SeamlessRegistrationService {
	constructor(
		private affiliateService: AffiliateService,
		private httpClient: CoreHttpClient,
		private config: SeamlessRegistrationConfigService
	) {}

	createRegistration(
		payload: SeamlessRegistrationPayload,
		product = ProductType.Common,
		jurisdiction = Jurisdiction.Mga
	): Observable<SeamlessRegistrationReferenceResponse> {
		return this.httpClient.post<SeamlessRegistrationReferenceResponse>({
			url: this.config.getSeamlessRegistrationEndpoint(),
			data: this.buildSeamlessRegistrationRequest(payload, product, jurisdiction),
		});
	}

	getRegistrationState(reference: string): Observable<SeamlessRegistrationResponse> {
		return this.httpClient.get<SeamlessRegistrationResponse>({
			url: `${this.config.getSeamlessRegistrationEndpoint()}/${reference}`,
		});
	}

	confirmRegistration(
		reference: string,
		request: CreateSeamlessRegistrationRequest
	): Observable<SeamlessRegistrationResponse> {
		return this.httpClient.patch<SeamlessRegistrationResponse>({
			url: `${this.config.getSeamlessRegistrationEndpoint()}/${reference}`,
			data: request,
		});
	}

	attachBonus(siteTrackingId: string, reference: string): Observable<object> {
		return this.httpClient.patch({
			url: `${this.config.getSeamlessRegistrationEndpoint()}/${reference}/bonus`,
			data: { siteTrackingId },
		});
	}

	private buildSeamlessRegistrationRequest(
		request: SeamlessRegistrationPayload,
		registeredFromProduct: ProductType,
		jurisdiction: Jurisdiction
	): SeamlessRegistrationRequest {
		const { email, country, currency, depositLimit, fraudToken } = request;
		return {
			email,
			country,
			currency,
			fraudToken,
			providerName: SEAMLESS_REGISTRATION_PROVIDER_TYPE.trustly,
			timeZone: "UTC",
			affiliateMetadata: {
				bannerTag: this.affiliateService.getPartnerId() || "",
				affiliate: this.affiliateService.getCookieName() || "",
			},
			depositLimit:
				(jurisdiction === Jurisdiction.Ukgc || jurisdiction === Jurisdiction.Mga) &&
				depositLimit &&
				depositLimit.depositLimitPeriod === DepositLimitPeriod.NoLimit
					? undefined
					: depositLimit,
			productMetadata: {
				registeredFromProduct,
			},
		};
	}
}
